import { without } from 'lodash';
import { labeled, enumRequired } from '../../util/joi';
import { schema as objectiveTypeBaseReasonInterestInAdvance } from './ObjectiveTypeBaseReasonInterestInAdvance.schema';
import { ImportantOption, importantOptions } from '../global/ImportantOption.enum';

export const schema = (Joi: any, label: string) => {
  const availableImportantOptions = without(
    importantOptions,
    ImportantOption.none.name,
    ImportantOption.most_important.name,
    ImportantOption.somewhat_important.name,
    ImportantOption.least_important.name
  );
  return Joi.object()
    .keys({
      type: enumRequired(Joi, availableImportantOptions, labeled(label, 'Interest in advance'))
    })
    .when(
      Joi.object({
        type: Joi.object().keys({ name: Joi.string().valid(ImportantOption?.important?.name) })
      }),
      {
        then: Joi.object({
          reason: objectiveTypeBaseReasonInterestInAdvance(
            Joi,
            labeled(label, 'Where interest in advance is important, why? - ')
          )
        })
      }
    );
};

export default {
  schema
};
